// Filename - pages/index.js

import React from "react";
import '../../assets/css/styles.css';
import { Link } from "react-router-dom";
import {ButtonDrawOutlineWhite} from "../../components/common"; 

const About = () => {
    return (
        <div>
            <section>
                <div class="flex items-center w-screen justify-center">
                    <img src={require("../../assets/img/logos/Logogreen.png")} alt="About Us" className="w-3/5"/>
                </div>
            </section>
            <section class="">
            <h1 class="text-4xl bold font-bold flex items-center w-screen justify-center mt-10 mb-5">About Macanista</h1>
            <div class="flex items-center w-screen justify-center">
                <p class=" w-3/5 text-lg ">
                Macanista is an engineering-driven technology company specializing in robotics. Our flagship product, INSERR, is revolutionizing disaster response by integrating cutting-edge robotics with a mission to save lives. With award-winning innovations, we aim to transform industries by pushing the boundaries of automation and AI-driven solutions. 
                </p>
            </div>
            </section>
            <section class="flex w-screen items-center justify-center content-center">
                <div class="grid grid-cols-2 w-3/5 items-center justify-center content-center">
                    <div>
                        <h1 class="text-4xl bold font-bold flex items-center justify-center mt-10 mb-5">Our Mission</h1>
                        <div class="flex items-center  justify-center m-1">
                            <p class=" text-lg ">To develop cutting-edge robotic solutions that enhance human capability, improve safety, and revolutionize industries through innovation and automation. </p>
                        </div>
                    </div>
                    <div>           
                        <h1 class="text-4xl bold font-bold flex items-center justify-center mt-10 mb-5">
                            Our Vision
                        </h1>
                        <div class="flex items-center  justify-center m-1">
                            <p class=" text-lg ">
                                To become a global leader in intelligent robotic systems, advancing innovative robotics platforms for a sustainable and technologically enhanced future. 
                            </p>
                        </div>
                    </div> 
                </div>
            </section>
            <section>

            </section>
            <section>
            <h1 class="text-2xl lg:text-4xl bold font-bold flex items-center w-screen justify-center p-5 lg:p-0 mt-10 mb-5">The humans behind our robots</h1>
            <div class="flex items-center w-screen justify-center">
                <p class=" w-3/5 text-lg ">
                    We are a team of engineers, designers, and innovators dedicated to creating cutting-edge robotic solutions that empower industries and enhance human capability. Our team is driven by a passion for technology and a commitment to excellence, working together to develop groundbreaking products that push the boundaries of automation and AI-driven solutions. At Macanista, we believe that the future of robotics lies in collaboration and creativity, and we are proud to be at the forefront of this exciting journey.
                </p></div>
                <div class="flex  justify-center content-center m-10">
                    <div class="flex lg:w-3/5 items-center text-lg   ">
                        <div class="flex justify-center items-center content-center  lg:w-1/5">
                            <img src={require("../../assets/img/portraits/julio.jpeg")} alt="Julio" class="rounded-full h-20 w-20 lg:w-40 lg:h-40"/>
                        </div>
                        <div>
                            <p class="bold font-bold">Julio D. Nogueira-Smith</p>
                            <p class="p-1 text-sm lg:text-lg">Co-Founder & CEO. Engineering innovator specializing in ROV and robotics solutions.</p>
                        </div>
                    </div>
                </div>
                <div class="flex  justify-center content-center m-10">
                    <div class="flex lg:w-3/5 items-center text-lg   ">
                        <div class="flex justify-center items-center content-center  lg:w-1/5">
                            <img src={require("../../assets/img/portraits/ryan.jpeg")} alt="Julio" class="rounded-full h-20 w-20 lg:w-40 lg:h-40"/>
                        </div>
                        <div>
                            <p class="bold font-bold">Ryan Pou Ut Chan</p>
                            <p class="p-1 text-sm lg:text-lg">Co-Founder, CTO/COO, CEO of MakerMods & Fish Logic Underwater Robotics Team Mentor.</p>
                        </div>
                    </div>
                </div>
            </section>
 
            <section>
            <h1 class="text-3xl bold font-bold flex items-center w-screen justify-center mt-10 mb-5">Our Partners</h1>
            <div class="flex items-center w-screen justify-center">
                <p class=" w-3/5 text-lg ">
                    Initial focus on Asia-Pacific and European markets, expanding into North America.
                    Key sectors: Maritime, security, healthcare, and research.
                </p>
            </div>
            </section>
            <section class="grid">

                <div class="w-screen mt-40 justify-center flex mb-40  box-sizing">
                    <div class="w-[90vw] lg:w-3/5 h-auto lg:h-[35vh]  justify-center flex  box-sizing">
                        <div class="h-full w-screen bg-gradient-to-r bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
    
                            <div class="p-5 mt-5">
                                <h2 class=" text-3xl lg:text-4xl  m-5 font-semibold  text-gray-900 dark:text-white">Our team for your sucess</h2>
                                <p class="m-5 text-base lg:text-xl text-justify text-gray-700 dark:text-gray-400">
                                Our team is here to help you do more. Get in touch with us to learn more about our products and services, or to schedule a demo. Connect with us on Social Media and stay up to date with the latest news and updates from Macanista. 
                                </p>
                                <Link to={"/inserr"} class="text-center font-semibold hover:text-black py-2 px-4 ">
                                    <ButtonDrawOutlineWhite>Connect With Us Now →</ButtonDrawOutlineWhite>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                
            </section>
        </div>
    );
};

export default About;
